module.exports = __webpack_public_path__ + "static/media/search-header.63467260.svg";